import { FC, useRef, useEffect, useState } from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import SwiperCore, { Navigation, Pagination } from 'swiper';
// SwiperCore.use([Navigation]);
import { Swiper, SwiperSlide ,Navigation,Pagination,} from 'apps/frontend/components/SwiperClient/SwiperClient';
import sliderimg from '../../../styles/images/cnbc-default-image.webp';
import GetData from '../../../services/GetData';
import { requests, fileUrl } from '../../../services/Requests';
import Link from 'next/link';
import { buildNewsRoute } from '../../..//services/Util';
import CategoriesLinks from '../CategoriesLinks/CategoriesLinks';
import TimeAgoArabicFormat from '../TimeAgoCustom/TimeAgoArabicFormat';
import Title from '../../Title';
import VideoDuration from '../../HelperComponents/VideoDuration';
import Thumbnail from '../../Thumbnail';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

const MostReadWebSlider: FC<{
}> = () => {
 
const navigationPrevRef = useRef(null);
const navigationNextRef = useRef(null);

const [mostReadNewsList, setMostReadNewsList] = useState<any>({});

useEffect(() => {
  GetData(`${requests.mostReadNews}&limit=10&offset=0`, {}, 'get', false)
    .then((res) => {
      const newsRes = res.data?.response ? res.data?.response : {};
      setMostReadNewsList(newsRes);
    })
    .catch((err) => {
      console.warn(err);
    });

  return () => {
    // This code runs when component is unmounted
    setMostReadNewsList({});
  };
}, []);

  return (
    <>
      <div className="newsSliderText newsSlider2Text video_newsSlider_wrap">
        <div className="heading_border  mt-5">
          <div className="row">
            <div className="col-sm-6">
              <div className="float-end">
                <Title styles={'yellowTitle'}>
                  <h3>الأكثر قراءة</h3>
                </Title>
              </div>
            </div>
            <div className="col-sm-6">

              <div className="sliderArrows text-start">
                <button
                  className="slider-arrow arrow-prev"
                  ref={navigationPrevRef}
                >
                  Previous
                </button>
                <button
                  className="slider-arrow arrow-next"
                  ref={navigationNextRef}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        <Swiper
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          dir="rtl"
          //   slidesPerView={4}
          spaceBetween={10}
          slidesPerGroup={1}
          breakpoints={{
            '1024': { slidesPerView: 4 },
            '768': { slidesPerView: 3 },
            '375': { slidesPerView: 1.5 },
            '320': { slidesPerView: 1.5 },
          }}
          pagination={false}
          modules={[Navigation, Pagination]}
          className="mySwiper"
        >
           {Object.values(mostReadNewsList).map(
            (news: any, index: number) => {
              news['routePath'] = buildNewsRoute(news?.id, news?.createdAt, news?.seoDetail?.slugLine, news?.title);
              return (
               
                  <SwiperSlide key={index}>
                    <div className="slider-item">
                      <div className="NewsBox ">
                        <Link href={`/${news?.routePath}`}>
                          <a href="#" aria-label="Go to 87">
                            <div className="newsImage">
                              {
                                // show thmbnail with play icon if video news
                                news?.contentType == 'VIDEO' ? (
                                  <>
                                    {news?.thumbnail?.url ? 
                                    <Thumbnail
                                      className={"img-fluid"}
                                      src={
                                        news?.thumbnail?.url
                                          ? news?.thumbnail?.url
                                          : news?.thumbnail?.path
                                              ? fileUrl + news?.thumbnail?.path
                                              : sliderimg.src
                                      }
                                      showThumbnail={true}
                                    />:<></>
                                    }
                                    <div className="PlayTime">
                                      <VideoDuration data={news?.video} />

                                      <div
                                        className="PlayButton-featured_50 PlayButton-base "
                                        data-type="play"
                                      >
                                        <span className="PlayButton-flyout">
                                          شاهد الآن
                                        </span>
                                        <span className="icon-play-triangle PlayButton-icon">
                                          <i className="fa play_medium"></i>
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                ) : // else show image
                                news?.image?.url ? 
                                <Thumbnail
                                    className={"img-fluid"}
                                    src={
                                      news?.image?.url
                                        ? news?.image?.url
                                        : news?.image?.path
                                            ? fileUrl + news?.image?.path
                                            : sliderimg.src
                                    }
                                    showThumbnail={true}
                                  />
                                  :
                                  <></>
                              }
                            </div>
                          </a>
                        </Link>
                        <div className="newscontent">
                          <h5>
                            <Link href={`/${news?.routePath}`}>
                              <a href="#" aria-label="Go to 88">{news?.title}</a>
                            </Link>
                          </h5>
                          <p>
                            <CategoriesLinks
                              categories={news && news?.categories}
                            />
                            <b>
                              <TimeAgoArabicFormat date={news?.createdAt} />
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                
              );
            })}
        </Swiper>
      </div>
    </>
  );
};

export default MostReadWebSlider;
